export default {
  getCurrentRole: (state: { user: { roles: { [x: string]: any; }; }; }) => (hotelId: number) => {
    const result: string[] = [];
    if (state.user && hotelId) {
      for (const index in state.user.roles) {
        const role = state.user.roles[index];
        const hotels = role.hotel_id.split(",");
        if (hotels.indexOf(String(hotelId)) != -1) {
          result.push(role.name);
        }
      }
    }
    return result.join(", ");
  }
};
